module.exports = __webpack_public_path__ + "static/media/minus_circle_blue.a73735d3.svg";